// extracted by mini-css-extract-plugin
module.exports = {"co2":"CO2_co2__1Txoq","researchSectionFadeIn":"CO2_researchSectionFadeIn__1LhCE","list":"CO2_list__1CYz_","item":"CO2_item__2MoEK","icon":"CO2_icon__3ydiM"};